import React, {Component, useMemo, useContext} from 'react';
import Slider from "react-slick";
import {Helmet} from "react-helmet";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleLeft} from '@fortawesome/pro-light-svg-icons/faAngleLeft';
import {faAngleRight} from '@fortawesome/pro-light-svg-icons/faAngleRight';
import {faPlay} from '@fortawesome/pro-solid-svg-icons/faPlay';
import {faPause} from '@fortawesome/pro-solid-svg-icons/faPause';
import {faExpand} from '@fortawesome/pro-solid-svg-icons/faExpand';
import {faCompress} from '@fortawesome/pro-solid-svg-icons/faCompress';
import {OpenHuisBanner} from '../components/menu/addons';
import {UncontrolledTooltip} from 'reactstrap';
import axios from "axios";
import LangContext from "../providers/LangContext";
import {Route} from "react-router-dom";
import FormModal from "../components/FormModal";
import BiddingModalNL from "../components/biddingforms/BiddingModalNL";
import BiddingModalBE from "../components/biddingforms/BiddingModalBE";
import {get} from "../inc/Http";
import {faTimesCircle} from "@fortawesome/pro-light-svg-icons/faTimesCircle";

class FullScreenPhotos extends Component {

    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.togglePlay = this.togglePlay.bind(this);
        this.toggleFullScreen = this.toggleFullScreen.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.afterChangeHandler = this.afterChangeHandler.bind(this);
        this.handleImageError = this.handleImageError.bind(this);

        this.infoBlock = React.createRef();
        this.state = {
            activeSlide: 0,
            playing: true,
            stopPlaying: false,
            swipeDownClass: 'showing',
            infoBlockHeight: 0,
            screenSize: 'small',
            imageErrors: false,
            fullScreen: false,
        }
        const csrf = document.head.querySelector('meta[name="csrf-token"]');

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf.content;
        axios.defaults.headers.common['X-localization'] = document.documentElement.lang;
    }

    afterChangeHandler(currentSlide, a) {

        if (this.state.stopPlaying) {
            this.setState({
                playing: false,
                stopPlaying: false,
                activeSlide: currentSlide
            });
        } else {
            this.setState({
                activeSlide: currentSlide
            });
        }
    }

    handleKeyDown = (event) => {
        switch( event.keyCode ) {
            case 37: //left arrow key
                this.previous();
                break;
            case 39: //right arrow key
                this.next();
                break;
            default:
                break;
        }
    }

    next() {
        if(this.slider) {
            this.slider.slickNext();
        }
    }

    previous() {
        if(this.slider) {
            this.slider.slickPrev();
        }
    }

    togglePlay() {
        if(this.slider) {
            this.setState({
                playing: !this.state.playing
            });

            if (this.state.playing) {
                this.slider.slickPause();
            } else {
                this.slider.slickPlay();
            }
        }
    }

    toggleFullScreen() {

        var element = document.documentElement;

        var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;

        element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () { return false; };
        document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () { return false; };

        if ( isFullscreen ) {

            document.cancelFullScreen();

            this.setState({
                fullScreen: false
            });

        }  else {

            element.requestFullScreen();

            this.setState({
                fullScreen: true
            });
        }

    }

    componentDidMount() {
        window.addEventListener("keydown", this.handleKeyDown);
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
        if (window.innerWidth > 992) {
            if (this.state.screenSize !== 'large') {
                this.setState({screenSize: 'large'})
            }
        } else {
            if (this.state.screenSize !== 'small') {
                this.setState({screenSize: 'small'})
            }
        }
    };

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener("keydown", this.handleKeyDown);
    };

    getCustomFormText() {
        get(`/site-data/{site}/bidding-form-text`)
    }

    handleResize() {

        if (window.innerWidth > 992) {
            if (this.state.screenSize !== 'large') {
                this.setState({screenSize: 'large'})
            }
        } else {
            if (this.state.screenSize !== 'small') {
                this.setState({screenSize: 'small'})
            }
        }
    }

    handleScroll(event, bb) {

        if (!this.infoBlock.current) {
            return;
        }
        let infoBlockHeight = this.infoBlock.current.clientHeight;

        if (window.scrollY < 200) {
            //    show
            this.setState({
                'swipeDownClass': 'showing',
                'infoBlockHeight': infoBlockHeight
            })

        } else {
            this.setState({
                'swipeDownClass': 'hiding',
                'infoBlockHeight': infoBlockHeight
            })
        }
    };

    handleImageError(e) {

        if(this.state.imageErrors || document.cookie.indexOf('_backoffice_notification') > 0) {
            return;
        }

        this.setState({
            imageErrors: true,
        });

        axios.post('/api/site/' + this.props.siteID + '/notify-backoffice', {
            message: 'Afbeelding kon niet worden geladen vanuit. Controleer de afbeeldingen en vernieuw de Api cache',
        }).then(response => {
        }).catch(error => {
        });
    }

    render() {
        if (!this.props.images || this.props.images.length === 0) {
            return '';
        }

        let lang = this.context.lang;
        let images = '';
        let settings = {
            dots: false,
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            arrows: false,
            slidesToScroll: 1,
            autoplay: this.state.playing,
            lazyLoad: 'progressive',
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: true,
            swipeToSlide: true,
            useTransform: false,

            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        autoplay: false,
                        className: "center",
                        centerMode: false,
                        vertical: true,
                        swipeToSlide: false,
                        centerPadding: "10px",
                        verticalSwiping: false,
                        swipe: false,
                        slidesToShow: this.props.images.length,
                        slidesToScroll: false,
                        touchThreshold: 100,
                    }
                }
            ]
        };

        let that = this;
        images = (
            this.props.images.map(function (el, index) {
                if (window.innerWidth > 992) {
                    //show the images horizontal if window width > 992
                    let img = new Image();
                    img.src = el.url;
                    // img.onerror = that.handleImageError; // is off because it sends a lot of emails
                    let classNameDirection = '';
                    if (img.width < img.height) {
                        classNameDirection = 'homepage-slide-portrait'
                    } else {
                        classNameDirection = 'homepage-slide-landscape'
                    }

                    return (
                        <div key={index}>
                            <div className={`homepage-slide d-none d-lg-block d-xl-block ${classNameDirection}`}
                                 style={{backgroundImage: 'url(' + el.url + ')'}}></div>
                        </div>
                    );

                } else {
                    //show the images vertical if window width < 992
                    return <div key={index}>
                        <div style={{marginBottom: '-9px'}}>
                            <img src={el.url_md} style={{width: '100%', height: 'auto'}}/>
                        </div>
                    </div>;
                }

            })
        );

        return (
            <div className="homepage-wrapper">
                <Helmet>
                    <link rel="stylesheet" type="text/css" charset="UTF-8"
                          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"/>
                    <link rel="stylesheet" type="text/css"
                          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"/>
                </Helmet>
                <div className="d-none d-lg-inline-flex slider-buttons-box">
                    <div className="btn btn-primary" onClick={this.previous}>
                        <FontAwesomeIcon size="2x" icon={faAngleLeft}/>
                    </div>
                    <div style={{color: 'white'}}>
                        <h4 className="slider-h4">
                            {this.state.activeSlide + 1} / {this.props.images.length}</h4>
                    </div>
                    <div className="btn btn-primary" onClick={this.next}>
                        <FontAwesomeIcon size="2x" icon={faAngleRight}/>
                    </div>
                    <button className="btn btn-primary" style={{
                        marginLeft: '10px',
                    }} onClick={this.togglePlay}>
                        {this.state.playing ? <FontAwesomeIcon size="1x" icon={faPause}/> :
                            <FontAwesomeIcon size="1x" icon={faPlay}/>}
                    </button>
                    <button className="btn btn-primary" style={{
                        marginLeft: '10px',
                    }} onClick={this.toggleFullScreen} id="toggle_full_screen">
                        {this.state.fullScreen ? <FontAwesomeIcon size="1x" icon={faCompress}/> :
                            <FontAwesomeIcon size="1x" icon={faExpand}/>}
                    </button>
                    <UncontrolledTooltip placement='top' target='toggle_full_screen'>
                        {this.state.fullScreen ? lang.get('sites.close_fullscreen') : lang.get('sites.open_fullscreen') }
                    </UncontrolledTooltip>
                </div>
                <div className="slider-wrapper" style={{"marginBottom": this.state.infoBlockHeight}}>
                    {images != '' && <Slider id="slider" ref={c => (this.slider = c)}  {...settings}
                                             afterChange={this.afterChangeHandler}>
                        {images}

                    </Slider>}
                </div>
                <div className={"swipe-down-container " + this.state.swipeDownClass}>
                    <span className={"swipe-down-block " + this.state.swipeDownClass}>
                        <img src="/images/swipe-down.png"/> {lang.get('sites.swipe_down')}
                    </span>
                </div>
                {this.props.openHuisBanner && <OpenHuisBanner bannerText={this.props.openHuisBanner}/>}
                {this.props.theme !=='era' &&
                <div id="info-block" className="mobile-address-container" ref={this.infoBlock}>
                    <h3>{this.props.street} {this.props.number}{this.props.addition}, {this.props.city}</h3>
                    <PriceAndBidding
                        price={this.props.purchasePrice}
                        status={this.props.availability}
                        bidding={this.props.online_bidding}
                        siteID={this.props.siteID}
                        online_bidding={this.props.online_bidding}
                        country={this.props.country}
                        biddingForms={this.props.biddingForms}
                        sitePrefix={this.props.sitePrefix}
                        // street={this.props.street}
                        // number={this.props.number+this.props.addition}
                        // city={this.props.city}
                        terms={this.props.terms}
                        renderModal={this.props.renderModal}
                        customFormText={this.props.customFormText}
                        customBiddingFormText={this.props.customBiddingFormText}
                    />
                </div>
                }
                {this.props.property_value_report === 1 &&
                    <div className="card bg-light mb-3" style={{position: 'fixed', right: '15px', bottom: (!!this.props.openHuisBanner ? '137px' : '51px' ), zIndex: 999, maxWidth: '240px'}}>
                        <span className="text-right pr-2 mb-0" style={{cursor: 'pointer'}}><FontAwesomeIcon icon={faTimesCircle} onClick={this.props.togglePropValRep} /></span>
                        <div className="card-body pt-0">
                            <p className="card-title mb-2" style={{fontSize: '18px', fontWeight: 'strong'}}>Wat is mijn woning waard?</p>
                            <p className="card-text">Ontvang direct een gratis woningwaarde indicatie.</p>
                            <WoningWaardeButton prefix={this.props.sitePrefix}/>
                        </div>
                    </div>
                }
                <div id={"loading_wrapper"} style={{'zIndex': '-2'}}>
                    <div className="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FullScreenPhotos;

const PriceAndBidding = (props) => {

    const {price, status, bidding, country, terms, renderModal, customBiddingFormText, siteID, sitePrefix} = props;
    const { lang } = useContext(LangContext);
    const BiddingForms = {
        nl: BiddingModalNL,
        be: BiddingModalBE,
    }

    const FormComponent = BiddingForms[country];

    if (bidding != "0") {
        return useMemo(() => {
            return(
                <h3 className="mobile-footer_text">
                    <span>{price}<span className="d-lg-none"> |</span></span>
                    <FormModal
                        formTitle={lang.get('sites.bidding_modal_header')}
                        renderModal={renderModal}
                        sitePrefix={sitePrefix}
                        btnText={lang.get("sites.bidding_modal_btn")}
                        formContent={<FormComponent online_bidding={bidding} className={''} terms={terms} theme={'light'} formContent={FormComponent} customBiddingFormText={customBiddingFormText} siteID={siteID}/>}
                    />
                </h3>
            )
        }, [renderModal, price, status]);
    }

    return <h3>{status && <>{status} | </>}{price}</h3>;
};

export {PriceAndBidding};

const WoningWaardeButton = ({prefix}) => (
    <Route render={({ history}) => (
        <button
            type='button'
            className="btn btn-primary btn-block woningwaarde-check"
            onClick={() => { history.push(`${prefix}woningwaarde`) }}
        >
            Doe de gratis check
        </button>
    )} />
)
